import { Spin } from "antd";
import { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import SingleLoanServices from "services/services/SingleLoanServices";
import '../tenders/singleLoan/LoanOfferComparison.scss';
import { useParams } from 'react-router';

const LoanOfferComparisonPdf = (props: any) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [allBanks, setAllBanks] = useState<any>([]);
    const [loanData, setLoanData] = useState<any>();
    const [saveData, setSaveData] = useState<any>();
    const [bankList, setBankList] = useState<any>();
    const params =  useParams();

    useEffect(() => {
        console.log(props)
        getLoanData();
        getBankData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAllOffers = (id:any) =>{
        let obj:any = {};
        obj.loan_credit_id = id;
        obj.tender_id = params?.loan_tender_id;
        setLoading(true);
        SingleLoanServices
        .getAllOffers(obj)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                setAllBanks(response?.data?.data)
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    }

    const getLoanData = () => {
        setLoading(true);

        let paramsId = props.loan_tender_id

        SingleLoanServices
        .getSingleLoanData(paramsId)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                const responseVal = response?.data?.data
                getAllOffers(responseVal?.LOAN_DATA?.loan_data_credit_id)
                setLoanData(responseVal)
                setSaveData({ ...saveData, loan_tender_id: paramsId, loan_credit_id: responseVal?.LOAN_DATA?.loan_data_credit_id, attachment_ids: responseVal?.LOAN_DATA?.LOAN_DOC })
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    };

    const getBankData = () => {
        setLoading(true);
        let obj: any = {};
        obj.size = -1;

        SingleLoanServices
            .getAllBank(obj)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    setBankList(response?.data?.data)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    };

    return (
        <>
            <Spin spinning={loading}>
                <div className='mt-4 cu-table-border' >
                     <table className="table table-sm table-bordered" >
                                <thead className="cu-bg-subgreen">
                                    <tr className='cu-bg-subgreen align-top'>
                                        <th scope="col" className='text-left'>{props?.TranslateString('bank')}</th>
                                        <th scope="col" className='text-left'>{loanData?.LOAN_DATA?.loan_data_bank_group}</th>
                                        {
                                            allBanks?.map((element:any,index:any)=>{
                                                return <th scope="col" className='text-left text-white text-nowrap' key={index+Math.random()}>{element?.BANK_DATA?.bank_name}</th>;
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody >
                                    {<>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td width="30%">{props?.TranslateString("Loan amount")}</td>
                                            <td className='cu-bg-lightgreen3'>{loanData?.LOAN_DATA?.loan_data_agreement}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{element?.offer_capital || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Margin")}</td>
                                            <td className='cu-bg-lightgreen3'>{loanData?.LOAN_DATA?.loan_data_margin}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{element?.offer_margin || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Loan time")}</td>
                                            <td className='cu-bg-lightgreen3'>{loanData?.LOAN_DATA?.loan_data_period}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{element?.offer_margin || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Repayment method")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{element?.offer_payment_method || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Number of yearly payment")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{ "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Loan transfer sanction %")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{ "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left border-white'><td colSpan={9}>&nbsp;</td></tr>
                                        <tr className='text-left border-white fw-bold' key={Math.random()}>
                                            <td>{""}</td>
                                            <th colSpan={allBanks?.length}>
                                                {props?.TranslateString("Loan tendering costs")}
                                            </th>
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Banks arrangement fee €")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{element?.bank_arrangement_fee || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Loan transfer sanction €")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{element?.loan_transfer_sanction || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Estimated price of mortage transfer")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{element?.offer_estimated_mortage_price || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("rettas_fee_vat_24")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{element?.rettas_fee || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Total costs")} €</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{element?.total_costs || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left border-white fw-bold' key={Math.random()}>
                                            <td>{""}</td>
                                            <th colSpan={allBanks?.length+1}>
                                                {props?.TranslateString("Costs or savings related to reference rate check")}
                                            </th>
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td ><span className={`text-danger`}>*</span>&nbsp;{props?.TranslateString("Current reference rate of the loan %")}</td>
                                            <td className='p-0 h-100' colSpan={allBanks.length+1}>
                                                <div className={`box-size-1 text-right bg-warning`}>0.00%</div>
                                            </td>
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td ><span className={`text-danger`}>**</span>&nbsp;{props?.TranslateString("Time remaining to reference rate check (months)")}</td>
                                            <td className='p-0 h-100' colSpan={allBanks.length+1}>
                                                <div className={`box-size-1 text-right bg-warning`}>{loanData?.LOAN_DATA?.time_remaining || "-"}</div>
                                            </td>
                                        </tr>
                                        <tr className='text-left border-white fw-bold' key={Math.random()}>
                                            <th colSpan={allBanks?.length+1}></th>
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Reference rate")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{loanData?.LOAN_DATA?.reference_interest_rate || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td ><span className={`text-danger`}>***</span>&nbsp;{props?.TranslateString("Reference rate today")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{loanData?.LOAN_DATA?.reference_rate_today || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Cost/profit of reference rate change €")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{loanData?.LOAN_DATA?.cost_of || "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        {/* <tr className='text-left border-0' key={Math.random()}>
                                            <td className={`text-danger py-0 border-0`}>{"Arvio pankin uudelleenrahoituskuluista €"}</td>
                                            <td className={`py-0 border-0`} colSpan={allBanks.length}>{"\"Disclaimer about possible other costs\""}</td>
                                        </tr>
                                        <tr className='text-left border-white' key={Math.random()}>
                                            <td className={`py-0 border-0`} colSpan={allBanks?.length+1}>
                                                Finland's Bank - daily Euribor rates
                                            </td>
                                        </tr> */}
                                        <tr className='text-left border-white' key={Math.random()}>
                                            <th></th>
                                            <th colSpan={allBanks?.length} className={`py-0 border-0`}>
                                                {props?.TranslateString("Loan cost comparison and savings") }
                                            </th>
                                        </tr>
                                        <tr className='text-left border-white cu-text-smaller' key={Math.random()}>
                                            <th></th>
                                            <th colSpan={allBanks?.length}>
                                                {props?.TranslateString("1. Refinancing costs covered with income financing")}
                                            </th>
                                        </tr>
                                        <tr className='text-left border-white' key={Math.random()}>
                                            <th></th>
                                            <td colSpan={allBanks?.length+2} className={`py-0 border-0 cu-text-smaller`}>
                                                {props?.TranslateString("Mikäli järjestelypalkkiot maksetaan tulorahoituksella ja lainapääoma pidetään samana, ei tarvita yhtiökokousta. Laskennassa pankin jälleenrahoituskustannukset on jyvitetty tasaisesti lyhennysjaksoille ja Rettan palkkio maksetaan ensimmäisen vuoden aikana.")}
                                            </td>
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Total costs")} €</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{ "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("1st year savings")} €</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{ "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Total Savings")} €</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{ "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left border-white cu-text-smaller' key={Math.random()}>
                                            <th></th>
                                            <th colSpan={allBanks?.length}>
                                                {props?.TranslateString("2. Refinancing costs capitalised")}
                                            </th>
                                        </tr>
                                        <tr className='text-left border-white' key={Math.random()}>
                                            <th></th>
                                            <td colSpan={allBanks?.length+2} className={`py-0 border-0 cu-text-smaller`}>
                                                {props?.TranslateString("If the refinancing costs are capitalised, general meeting decision is required.")}
                                            </td>
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Total loan (incl. refinancing costs)")}</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{ "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Total costs")} €</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{ "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("1st year savings")} €</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{ "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left cu-table-row' key={Math.random()}>
                                            <td >{props?.TranslateString("Total savings")} €</td>
                                            <td className='cu-bg-lightgreen3'>{""}</td>
                                            {
                                                allBanks?.map((element:any,index:any)=>{
                                                    return <td className='text-left ' key={index+Math.random()}>{ "-"}</td>;
                                                })
                                            }
                                        </tr>
                                        <tr className='text-left border-0' key={Math.random()}>
                                            <td className={`text-danger py-0 border-0`}></td>
                                            <td className={`py-0 border-0 cu-text-smaller`} colSpan={allBanks.length+1}>{"Säästöissä on huomioitu muutos lainakustannuksissa, jälleenrahoituskustannukset, Rettan veloittama järjestelypalkkio sekä viitekoron tarkistukseen liittyvät kustannukset/säästöt /Savings include change in loan costs, refinancing costs, Retta's arrangement fee and costs/savings related to reference rate check."}</td>
                                        </tr>
                                        <tr className='text-left border-white' key={Math.random()}>
                                            <th></th>
                                            <th colSpan={allBanks?.length+1} className={`py-0 border-0`}>
                                                {props?.TranslateString("Recommendation") }
                                            </th>
                                        </tr>
                                    </>
                                    }
                                </tbody>
                            </table> 
                </div>
            </Spin>
        </>
    );
};
export default LoanOfferComparisonPdf;